var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['step-number-container', _vm.selected ? 'selected':'']},[_c('span',{staticClass:"step-number-label"},[_vm._v(_vm._s(_vm.stepNumber))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c556dffa","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/StepNumber.vue
// module id = 410
// module chunks = 1